import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const badgeVariants = cva(
    "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
    {
        variants: {
            variant: {
                default:
                    "border-transparent bg-primary/15 text-primary hover:bg-primary/25",
                success:
                    "border-transparent bg-success/15 text-success hover:bg-success/25",
                destructive:
                    "border-transparent bg-destructive/15 text-destructive hover:bg-destructive/25",
                outline:
                    "border-border/60 text-muted-foreground hover:bg-secondary/40",
                muted:
                    "border-transparent bg-secondary/40 text-secondary-foreground hover:bg-secondary/55",
            },
        },
        defaultVariants: {
            variant: "default",
        },
    },
);

export interface BadgeProps
    extends React.HTMLAttributes<HTMLDivElement>,
        VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
    return (
        <div className={cn(badgeVariants({ variant }), className)} {...props} />
    );
}

export { Badge, badgeVariants };

